<script>
    import { afterUpdate } from 'svelte'
    import Gradient from 'javascript-color-gradient'
    const colorGradient = new Gradient()
    import SimplexNoise from 'simplex-noise'
    import palette from './utils/palette'
    import {
        hightToLow,
        minusToPlus,
        forNoise
    } from './utils/featureToValue'
    import logic from './logic.js'

    colorGradient.setMidpoint(20)
    colorGradient.setGradient(...palette[window.$fxhashFeatures.palette])
    const colors = colorGradient.getArray()

    const offsetX = -196
    const offsetY = 295
    const rotate = 321.4
    const scaleSVG = 0.8
    const colorNoise1 = 1920
    const colorNoise2 = 5000
    const steps = 1000
    const majorRipple = 74
    const minorRipple = 410
    const radius = 650
    const scale = 200.71
    const q = 1
    const m = 0.35
    const n = 1
    const noiseScale = forNoise ( window.$fxhashFeatures.brokenness)
    const min = -5000
    const max = 5000
    const min2 = -5000
    const max2 = 5000
    const renderShapes = true
    const removePoint =minusToPlus ( window.$fxhashFeatures.brokenness)
    const renderAsCurve = true
    const sizeMin = 0
    const sizeMax = 56893
    const polyScale = hightToLow( window.$fxhashFeatures.brokenness)
    const p1 = 1
    const p2 = 1
    const p3 = 3
    const p4 = 1
    const p1_r = 28
    const p2_r = 0
    const p3_r = 0
    const p4_r = 0
    // p4_r = [p1_r, p2_r, p3_r, p4_r].every((i) => i % 2 === 0) ? p4_r + 1 : p4_r

    const borderSteps = 100

    $: result = logic({
        steps,
        majorRipple,
        minorRipple,
        sizeMin,
        sizeMax,
        radius,
        scale,
        q,
        m,
        n,
        noiseScale,
        min,
        max,
        min2,
        max2,
        removePoint,
        p1,
        p2,
        p3,
        p4,
        p1_r,
        p2_r,
        p3_r,
        p4_r,
        borderSteps,
        polyScale,
        renderAsCurve
    })

    let simplex = new SimplexNoise(fxhash)
    afterUpdate(fxpreview)
</script>

    <svg viewBox="0 0 1200 1200">
        <rect x="0" y="0" width="1200" height="1200" fill="white" />
        <!-- <rect x="100" y="100" width="1000" height="1000" fill="#34434c" /> -->

        <g
            transform={`translate(${600 + offsetX} ${
                600 + offsetY
            }) scale(${scaleSVG})  rotate(${rotate} )`}
        >
            {#each result.voronoi as d, i}
                <path
                    stroke={'#000'}
                    stroke-width={25.7}
                    stroke-linecap={'round'}
                    d={d + 'Z'}
                />
            {/each}
            {#each result.voronoi as d, i}
                <path
                    stroke={'#fff'}
                    stroke-width={25}
                    stroke-linecap={'round'}
                    d={d + 'Z'}
                />
            {/each}
            <!-- content here -->
            {#each result.voronoi as d, i}
                <path
                    fill={colors[
                        Math.floor(
                            Math.abs(
                                (1 +
                                    simplex.noise2D(
                                        i / colorNoise1,
                                        i / colorNoise2
                                    )) /
                                    2
                            ) * colors.length
                        )
                    ]}
                    stroke={renderAsCurve
                        ? 'rgba(0,0,0,0.2)'
                        : colors[
                              Math.floor(
                                  Math.abs(
                                      (1 +
                                          simplex.noise2D(
                                              i / colorNoise1,
                                              i / colorNoise2
                                          )) /
                                          2
                                  ) * colors.length
                              )
                          ]}
                    stroke-width={renderAsCurve ? 0.6 : 4}
                    {d}
                />
            {/each}
            <!-- content here -->

            <path fill="none" stroke="#fff" d={result.line} stroke-width="15" />
            <path
                fill="none"
                stroke="rgba(0,0,0,0.9)"
                d={result.line}
                stroke-width="0.4"
            />
        </g>
    </svg>

<style>
    svg {
        height: 100%;
        width: 100%;
    }
</style>
